var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCebabeMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 13.7754C13.4254 13.7754 14.125 13.0758 14.125 12.2129C14.125 11.3499 13.4254 10.6504 12.5625 10.6504C11.6996 10.6504 11 11.3499 11 12.2129C11 13.0758 11.6996 13.7754 12.5625 13.7754Z",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 6.65039C13.4254 6.65039 14.125 5.95084 14.125 5.08789C14.125 4.22495 13.4254 3.52539 12.5625 3.52539C11.6996 3.52539 11 4.22495 11 5.08789C11 5.95084 11.6996 6.65039 12.5625 6.65039Z",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 20.9004C13.4254 20.9004 14.125 20.2008 14.125 19.3379C14.125 18.4749 13.4254 17.7754 12.5625 17.7754C11.6996 17.7754 11 18.4749 11 19.3379C11 20.2008 11.6996 20.9004 12.5625 20.9004Z",
    fill: "#535353"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCebabeMenuIcon);
export default __webpack_public_path__ + "static/media/cebabe_menu_icon.1f2a547562a814daddb798ab682856bc.svg";
export { ForwardRef as ReactComponent };